import React from 'react'
import Select from 'react-select'
import './index.scss'

export const CustomSelect = ({
  label,
  value,
  onChange,
  name,
  placeholder,
  options,
  error,
  onInputChange,
  loading,
  inputRef
}: {
  label: string,
  value: { value: string, label: string },
  onChange: any,
  onInputChange?: any,
  name: string,
  type: string,
  placeholder: string,
  options: { value: string, label: string }[],
  error?: string,
  loading?: boolean,
  inputRef?: React.RefObject<any>,
}) => {

  const inputId = `${name}-input`

  return (
    <div className='custom-input'>
      <label htmlFor={inputId}>{label}</label>
      <Select
        aria-label={label}
        ref={inputRef}
        id={inputId}
        styles={{
          control: (baseStyles) => ({
            ...baseStyles,
            borderColor: '#949494!important',
            borderRadius: '0ox',
            padding: '7px 10px'
          }),
          placeholder: (baseStyles) => ({
            ...baseStyles,
            color: '#949494'
          }),
          option: (baseStyles, { isFocused, isSelected }) => ({
            ...baseStyles,
            color: '#212529',
            backgroundColor: isFocused ? '#eee' : isSelected ? '#eee' : '#fff',
            ':hover': {
              backgroundColor: '#eee'
            },
            ':active': {
              backgroundColor: '#eee'
            }
          }),
          singleValue: (baseStyles) => ({
            ...baseStyles,
            color: '#212529'
          }),
        }}
        defaultInputValue=''
        name={name}
        value={value.value ? value : ''}
        onInputChange={onInputChange}
        onChange={(e) => {
          onChange(name, typeof e === 'object' ? e?.value : '')
        }}
        placeholder={placeholder}
        options={options}
        noOptionsMessage={() => !loading ? (
          'No options'
        ) : (
          <div className='custom-select-loading-holder'>
            <div className="loader"></div>
          </div>
        )}
      />
      {error && <p className='error'>{error}</p>}
    </div>
  )
}